import { render, staticRenderFns } from "./email_history.vue?vue&type=template&id=63eedcd6"
import script from "./email_history.vue?vue&type=script&lang=js"
export * from "./email_history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports